import { render, staticRenderFns } from "./ShiftTypeSelect.vue?vue&type=template&id=724cfcdc"
import script from "./ShiftTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ShiftTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports